module.exports = __webpack_public_path__ + "img/yellow-gradient.b356d98b.svg";